module.exports = __webpack_public_path__ + "static/vacationApply.6f1804f4.svg";